import { ReactNode } from 'react';

import { Box, Heading, List, ListItem, Text } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';

import { PartnershipsTemplate } from '../model';

export type WaysToPartnerSectionProps = {
  ctaSlot?: ReactNode;
  title: string;
  waysToPartner: PartnershipsTemplate['waysToPartnerList'];
};

const COLORS = ['accent.lime', 'accent.purple', 'accent.sea-foam.500', 'accent.sky.500'] as const;

export function WaysToPartnerSection({ ctaSlot = null, title, waysToPartner = [] }: WaysToPartnerSectionProps) {
  return (
    <Box
      as='section'
      py={{
        base: 10,
        md: 20,
      }}
    >
      <ContentContainer>
        <HeadingWithEmphasis
          text={title}
          emphasisProps={{
            color: 'blue.500',
          }}
          headingProps={{
            as: 'p',
            size: 'marketing-4xl',
            textAlign: 'center',
            mb: 12,
          }}
        />
        <List
          as='ol'
          display='flex'
          flexWrap='wrap'
          gap={6}
          mb={12}
          sx={{
            counterReset: 'item',
          }}
        >
          {waysToPartner.map((way, idx) => {
            const color = COLORS[idx % COLORS.length];
            return (
              <ListItem key={idx} flex='1 1 262px'>
                <Card
                  bgColor='blue.800'
                  border='none'
                  borderRadius='lg'
                  color='white'
                  height='100%'
                  p={6}
                  sx={{
                    '&::before': {
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      content: `counter(item)`,
                      counterIncrement: 'item',
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      bgColor: color,
                      color: 'black',
                      fontFamily: 'heading',
                      fontSize: '21px',
                      fontWeight: 500,
                      mb: 4,
                    },
                  }}
                >
                  <Heading as='p' color={color} mb={4} size='marketing-xl'>
                    {way.title}
                  </Heading>
                  <Text>{way.text}</Text>
                </Card>
              </ListItem>
            );
          })}
        </List>
        {ctaSlot}
      </ContentContainer>
    </Box>
  );
}
